import { AssetDTO, FormElementKind } from '@gearbelt/global';
import { useNavigate, useParams } from 'react-router-dom';

import { AssetSelectFormElement } from '@/components/form/elements/asset-select';
import ArrowLeftIcon from '@/components/icons/arrow-left';

export function AWAScheduleChecksPage() {
  const { workspaceId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="flex h-[100dvh] w-full flex-col gap-4 bg-white">
      <div className="border-b-grey-3 flex items-center justify-between border-b-2 px-4 py-4">
        <div className="flex items-center gap-1">
          <button onClick={() => navigate(`/${workspaceId}/maintenance`)}>
            <ArrowLeftIcon size={30} />
          </button>
          <div className="line-clamp-1 text-lg font-medium">Select Asset</div>
        </div>
      </div>
      <div className="flex flex-col gap-1 px-4">
        <AssetSelectFormElement
          element={{ id: 'assetId', kind: FormElementKind.AssetSelect, label: 'Asset', required: true, config: { multiple: false } }}
          value=""
          onChange={() => {}}
          onChangeFull={(value) => {
            const asset = value as AssetDTO;
            if (asset) {
              navigate(`/${workspaceId}/schedule-checks/${asset.id}`);
            }
          }}
        />
        <div className="text-secondary-text text-center">Select an asset to view its check records</div>
      </div>
    </div>
  );
}
